// extracted by mini-css-extract-plugin
export default {"ad-details__reason":"ad-details_ad-details__reason__P-Og9"};